import {createSlice} from "@reduxjs/toolkit";
import {apiCall} from "./apiAction";

const slice = createSlice({
    name: 'worker',
    initialState: {
        workers: [],
        count: 0,
        total_pages: 1,
        message: false,
        worker_single: false
    },
    reducers: {
        getAllWorker: (state, action) => {
            state.workers = action.payload.results
            state.count = action.payload.count
            state.total_pages = action.payload.total_pages
        },
        getOneWorker: (state, action) => {
            state.worker_single = action.payload
        },
        saveWorker: (state, action) => {
            state.workers.unshift(action.payload)
            state.message = true
        },
        editWorker: (state, action) => {
            state.worker_single = action.payload
            state.workers = state.workers.map(item => item.id === action.payload.id ? action.payload : item)
            state.message = true
        },
        deleteToWorker: (state, action) => {
            state.workers = state.workers.filter(item => item.id !== action.payload.id)
            state.message = 'deleted'
        },
        messageReset: (state) => { state.message = false },
        messageFail: (state) => { state.message = 'error' }
    }
})

export const getWorkers = (page = 1, pageSize = 20, search = '', passport = '', regionId = '', viloyatId = '') => apiCall({
    url: `worker/?page=${page}&page_size=${pageSize}${search ? `&search=${search}` : ''}${passport ? `&passport=${passport}` : ''}${regionId ? `&region_id=${regionId}` : ''}${viloyatId ? `&viloyat_id=${viloyatId}` : ''}`,
    method: 'GET',
    onSuccess: slice.actions.getAllWorker.type
})

export const workerSave = (data) => apiCall({
    url: 'worker/',
    method: 'POST',
    onSuccess: slice.actions.saveWorker.type,
    onFail: slice.actions.messageFail.type,
    data,
})

export const getWorker = (id) => apiCall({
    url: 'worker/' + id,
    method: 'GET',
    onSuccess: slice.actions.getOneWorker.type,
})

export const editSaveWorker = (data) => apiCall({
    url: 'worker/' + data.id + '/',
    method: 'PUT',
    onSuccess: slice.actions.editWorker.type,
    onFail: slice.actions.messageFail.type,
    data,
})

export const deleteWorker = (data) => apiCall({
    url: 'worker/' + data.id + '/',
    method: 'DELETE',
    onSuccess: slice.actions.deleteToWorker.type,
    onFail: slice.actions.messageFail.type,
})

export default slice.reducer
export const {messageReset, getAllWorker} = slice.actions